module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newArticle"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    内容管理 >\n    "), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存为草稿")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.issue
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("预览")])], 1), _vm._v(" "), _c('div', {
    staticClass: "articleDetail"
  }, [_c('el-form', {
    ref: "articleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.articleForm,
      "label-width": "110px"
    }
  }, [_c('el-form-item', [_c('el-checkbox', {
    staticClass: "containVideo",
    model: {
      value: (_vm.articleForm.containVideo),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "containVideo", $$v)
      },
      expression: "articleForm.containVideo"
    }
  }, [_vm._v("\n          内容包含视频\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n            将文件拖到此处，或\n            "), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("图片规格650*350")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "列表图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.uploadSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n            将文件拖到此处，或\n            "), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("图片规格650*350")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleTitle",
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的标题，不超过50个字符"
    },
    model: {
      value: (_vm.articleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "title", $$v)
      },
      expression: "articleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleAbstract",
    attrs: {
      "label": "摘要",
      "prop": "abstract"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "不超过100个字符"
    },
    model: {
      value: (_vm.articleForm.abstract),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "abstract", $$v)
      },
      expression: "articleForm.abstract"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleAuthor",
    attrs: {
      "label": "作者",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": function($event) {
        return _vm.selectAuthor()
      }
    },
    model: {
      value: (_vm.articleForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "phone", $$v)
      },
      expression: "articleForm.phone"
    }
  }), _vm._v(_vm._s(_vm.articleForm.authorInfo) + "\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleType",
    attrs: {
      "label": "类别",
      "prop": "type"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.articleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "type", $$v)
      },
      expression: "articleForm.type"
    }
  }, _vm._l((_vm.categories), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.articleForm.schObj
    },
    on: {
      "changeVal": _vm.getVal
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.articleForm.isPublished
    },
    model: {
      value: (_vm.articleForm.ifNotice),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "ifNotice", $$v)
      },
      expression: "articleForm.ifNotice"
    }
  }, [_vm._v("首次发布，向所有用户发送更新通知")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleContent",
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('editor', {
    ref: "myTextEditor",
    attrs: {
      "fileName": 'uploadFile',
      "canCrop": _vm.canCrop,
      "uploadUrl": _vm.actionUrl
    },
    model: {
      value: (_vm.articleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "content", $$v)
      },
      expression: "articleForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "文章预览",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51f84e94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/about/about.vue
// module id = 1028
// module chunks = 0